import React, { useEffect, useState } from 'react';
import { Box, Button, Menu, MenuItem, Typography, SvgIcon } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { BackIcon } from 'Components/Icons';
import { logoutUser } from './actions';
import { AccountCircleOutlined } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { pusher } from 'helpers/websocket';
import { setSuccessToastState } from 'Store/action';
import { AppDispatch, RootState } from 'Store/Store';
import { UserType } from 'shared/types/User.types';
import LHS from './LHS/LHS';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate, useLocation } from 'react-router-dom';

const theme = createTheme({
  components: {
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          color: '#262626',
        },
      },
    },
  },
});

const classes = {
  content: {
    flexGrow: 1,
    backgroundColor: '#FFF',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
    backgroundPosition: 'center',
    overflow: 'auto',
    height: '100vh',
  },
  topContainer: {
    minHeight: 60,
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid rgba(0, 0, 0, 0.20)',
  },
};

const NavigationLayout: React.FC<{ children: React.ReactElement }> = ({
  children,
}): React.ReactElement => {
  const dispatch = useDispatch<AppDispatch>();
  const user: UserType | null = useSelector(({ user }: RootState) => user.user);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutUser = (): void => {
    dispatch(logoutUser()).then(() => {
      handleClose();
    });
  };

  useEffect(() => {
    if (user?.is_super_admin) {
      pusher
        .subscribe('artwork_version')
        .bind('pages_made', (data: { allowed_users_ids: any[]; brand_request_id: number }) => {
          if (data?.allowed_users_ids.includes(user?.id)) {
            dispatch(
              setSuccessToastState(
                true,
                'Artwork Pages Generated Successfully',
                data?.brand_request_id,
                true,
              ),
            );
          }
        });
      pusher
        .subscribe('client_artwork_version')
        .bind('pages_made', (data: { allowed_users_ids: any[]; brand_request_id: number }) => {
          if (data?.allowed_users_ids.includes(user?.id)) {
            dispatch(
              setSuccessToastState(
                true,
                'Artwork Pages Generated Successfully',
                data?.brand_request_id,
              ),
            );
          }
        });
    } else {
      pusher
        .subscribe('client_artwork_version')
        .bind('pages_made', (data: { allowed_users_ids: any[]; brand_request_id: number }) => {
          if (data?.allowed_users_ids.includes(user?.id)) {
            dispatch(
              setSuccessToastState(
                true,
                'Artwork Pages Generated Successfully',
                data?.brand_request_id,
              ),
            );
          }
        });
    }
  }, [dispatch, user]);
  const location = useLocation();

  const navigate = useNavigate();

  const handleGoBack = () => {
    const pathSegments = location.pathname.split('/');
    const currentProject = pathSegments[3];
    const backToPage = pathSegments[1];

    if (pathSegments[3] === 'client-brief' && backToPage === 'live-projects') {
      navigate('/live-projects');
    } else if (pathSegments[3] === 'client-brief' && backToPage === 'pending-projects') {
      navigate('/pending-projects');
    } else if (pathSegments[3] === 'client-brief' && backToPage === 'rejected-projects') {
      navigate('/rejected-projects');
    } else {
      navigate(-1);
    }
  };

  return user?.id ? (
    <Box sx={{ display: 'flex' }}>
      <LHS user={user} />
      <Box component="main" sx={classes.content}>
        <Grid container direction="column" justifyContent="center" flexWrap="nowrap">
          <Grid container direction="row" sx={classes.topContainer} spacing={2}>
            {/* Back Icon and Text */}
            <Box
              // onClick={handleGoBack}
              sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                padding: '8px 12px',
                gap: 1,
                borderRadius: '4px',
                '&:hover': {
                  backgroundColor: '#f0f0f0',
                },
              }}>
              {/* <BackIcon /> */}
              <Typography
                sx={{
                  fontSize: '16px',
                  color: '#000',
                  fontWeight: 500,
                }}>
                {/* Back */}
              </Typography>
            </Box>
            <ThemeProvider theme={theme}>
              <Button
                onClick={handleClick}
                sx={{ color: '#262626' }}
                startIcon={<AccountCircleOutlined />}>
                {user?.name}
              </Button>
            </ThemeProvider>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
              <MenuItem
                onClick={() => {
                  handleLogoutUser();
                }}>
                Logout
              </MenuItem>
            </Menu>
          </Grid>
          {children}
        </Grid>
      </Box>
    </Box>
  ) : (
    <>{children}</>
  );
};

export default NavigationLayout;
